// pd-pre-product.liquid,pd-pre-product-grid.liquid文件中自定义 GA4方法公共js
const firedLists = new Set();

const SELECT_TARGETS = [
  { selector: '.poster-link', buttonName: 'product_poster' },
  { selector: '.variants-img-wrapper', buttonName: 'product_image' },
  { selector: '.product-title', buttonName: 'product_title' },
  { selector: '.product-link', buttonName: 'product_link' },
];

const parseMoney = (text) => {
  if (!text) return 0;
  return Number(String(text).split('€').join('').split(',').join('.').replace(/[^\d.-]/g, '')) || 0;
};

const getMappedFields = (sku) => {
  const fields = {
    item_name: '',
    item_variant: '',
    item_category: '',
    item_category2: 'Standard',
  };
  if (product_handle_map && product_handle_map.has(sku) && product_handle_valueMap[sku]) {
    const mapped = product_handle_valueMap[sku];
    fields.item_name = mapped[0] || '';
    fields.item_variant = mapped[1] || '';
    fields.item_category = mapped[2] || '';
    fields.item_category2 = mapped[3] || 'Standard';
  }
  return fields;
};

const getCardDiscount = (card) => {
  const priceEl = card.querySelector('.price.active');
  if (!priceEl) return { price: 0, discount: 0 };

  const priceClone = priceEl.cloneNode(true);
  priceClone.querySelectorAll('.tag_sale-compare-price').forEach((el) => el.remove());
  const price = parseMoney(priceClone.textContent);
  const compareEl = priceEl.querySelector('.tag_sale-compare-price');
  const compareAt = parseMoney(compareEl ? compareEl.textContent : '');
  const discount = compareAt > price ? +(compareAt - price).toFixed(2) : 0;
  return { price, discount };
};

const buildItem = (card, root) => {
  const dataEl =
    card.querySelector('.variant-wrapper.active .product-data-div') || card.querySelector('.product-data-div');
  const raw = dataEl ? dataEl.getAttribute('data-product-data') : '';
  if (!raw) return null;

  const data = raw.split('::');
  const mapped = getMappedFields(data[0]);
  const { price, discount } = getCardDiscount(card);
  const listPrice = price || parseMoney(data[9]);

  return {
    item_id: data[0],
    item_name: mapped.item_name || data[1] || '',
    discount,
    index: Number(card.dataset.gaIndex) || 1,
    item_list_id: root.dataset.itemListId || '',
    item_list_name: root.dataset.itemListName || '',
    item_category: mapped.item_category,
    item_category2: mapped.item_category2,
    item_category3: (data[6] || '').replace('Default Title', 'none'),
    item_variant: mapped.item_variant,
    item_brand: 'SHOKZ',
    price: listPrice,
    quantity: Number(data[10]) || 1,
    currency: root.dataset.currency || 'EUR',
  };
};

const pushGa4 = (eventName, eventParameters) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: 'ga4Event',
    event_name: eventName,
    event_parameters: eventParameters,
  });
};

const buildListItems = (root) =>
  Array.from(root.querySelectorAll('.buy-card'))
    .map((card) => buildItem(card, root))
    .filter(Boolean)
    .sort((a, b) => a.index - b.index);

const pushViewItemList = (items) => {
  if (!items.length) return;
  pushGa4('view_item_list', {
    item_list_id: items[0].item_list_id,
    item_list_name: items[0].item_list_name,
    currency: items[0].currency,
    items,
  });
};

const pushSelectItem = (item, buttonName) => {
  pushGa4('select_item', {
    item_list_id: item.item_list_id,
    item_list_name: item.item_list_name,
    button_name: buttonName,
    items: [
      {
        ...item,
        item_list_name: `Navigation _ ${item.item_list_name}`,
      },
    ],
  });
};

const pushAddToCart = (item, buttonName) => {
  pushGa4('add_to_cart', {
    button_name: buttonName,
    currency: item.currency,
    value: +(item.price * item.quantity).toFixed(2),
    item_list_id: item.item_list_id,
    item_list_name: item.item_list_name,
    items: [item],
  });
};

const getCardFromTarget = (target) => {
  const buyCard = target.closest('.buy-card');
  if (buyCard) return buyCard;
  const productBox = target.closest('.product-box');
  return productBox ? productBox.querySelector('.buy-card') : null;
};

const handleViewItemListClick = (event) => {
  const root = event.target.closest('[data-view-item-list]');
  if (!root) return;

  const addToCartBtn = event.target.closest('.addtocart');
  if (addToCartBtn && root.contains(addToCartBtn)) {
    if (addToCartBtn.disabled || addToCartBtn.classList.contains('disable')) return;
    const card = getCardFromTarget(addToCartBtn);
    const item = card ? buildItem(card, root) : null;
    if (item) pushAddToCart(item, addToCartBtn.textContent.trim() || 'add_to_cart');
    return;
  }

  SELECT_TARGETS.some(({ selector, buttonName }) => {
    const el = event.target.closest(selector);
    if (!el || !root.contains(el)) return false;
    const card = getCardFromTarget(el);
    const item = card ? buildItem(card, root) : null;
    if (item) pushSelectItem(item, buttonName);
    return true;
  });
};

const bindViewItemListRoot = (root) => {
  if (root.dataset.viewItemListBound === 'true') return;

  const cards = root.querySelectorAll('.buy-card');
  if (!cards.length) return;

  root.dataset.viewItemListBound = 'true';

  const listKey = `${location.pathname}|${root.dataset.itemListId || ''}`;
  const observer = new IntersectionObserver(
    (entries) => {
      const inView = entries.some((entry) => entry.isIntersecting);
      if (!inView) return;
      if (firedLists.has(listKey)) return;
      firedLists.add(listKey);
      pushViewItemList(buildListItems(root));
      observer.disconnect();
    },
    { threshold: 0 }
  );

  Array.from(cards).forEach((card) => observer.observe(card));
};

const initPdPreViewItemList = () => {
  try {
    document.addEventListener('click', handleViewItemListClick);
    document.querySelectorAll('[data-view-item-list]').forEach(bindViewItemListRoot);
  } catch (error) {
    console.warn('pd-pre view_item_list', error);
  }
};

document.addEventListener('DOMContentLoaded', initPdPreViewItemList);
